import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';
import loc from 'owa-localize';
import { showAsTentative } from 'owa-locstrings/lib/strings/showastentative.locstring.json';
import {
    rsvpOrganizerLabel,
    rsvpCanceledLabel,
    rsvpNotRespondedLabel,
    rsvpAcceptedLabel,
    rsvpDeclinedLabel,
} from './RSVPStatus.locstring.json';

import * as styles from './styles.scss';

export default observer(function RSVPStatus({ item }: { item: CalendarItem }) {
    const labelProps = computeRSVPIconLabel(item);

    if (!labelProps) {
        return null;
    }

    const { icon, label } = labelProps;

    return (
        <div className={styles.rsvpStatus}>
            <Icon className={styles.calendarResponseIcon} iconName={icon} />
            <span className={styles.rsvpStatusText} title={label}>
                {label}
            </span>
        </div>
    );
});

function computeRSVPIconLabel(item: CalendarItem): { icon: string; label: string } | null {
    if (item.IsOrganizer) {
        return {
            icon: ControlIcons.Event,
            label: loc(rsvpOrganizerLabel),
        };
    }

    if (item.IsCancelled) {
        return {
            icon: ControlIcons.RemoveEvent,
            label: loc(rsvpCanceledLabel),
        };
    }

    switch (item.ResponseType) {
        case 'NoResponseReceived':
            return {
                icon: ControlIcons.EventTentative,
                label: loc(rsvpNotRespondedLabel),
            };
        case 'Accept':
            return {
                icon: ControlIcons.EventAccepted,
                label: loc(rsvpAcceptedLabel),
            };
        case 'Tentative':
            return {
                icon: ControlIcons.EventTentative,
                label: loc(showAsTentative),
            };
        case 'Decline':
            return {
                icon: ControlIcons.EventDeclined,
                label: loc(rsvpDeclinedLabel),
            };
    }

    return null;
}
